export default __webpack_public_path__ + "static/media/pipeRB.d7510c06.png";